<app-layout [block]="layout()">
    @for(child of block().body; track child['_uid']){
        <s1-cms-component [blok]="child" />
    }
</app-layout>
